var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"modal-backdrop",on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.clickBackdrop.apply(null, arguments)}}},[_c('div',{staticClass:"modal"},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }